import { download, generateCsv, mkConfig } from "export-to-csv"
import { MRT_Row } from "material-react-table"
import { useDateTime } from "../../../../../localization/useDateTime"
import { useMoney } from "../../../../../currency/useMoney"
import { toCurrency, toDinero } from "../../../../../currency/currencyLib"
import { SubscriptionOrder } from "../../../../../company/reports/accounting/subscriptions/subscriptionsTypes"

export const useExportSubscriptions = (chosenStartDate: string, chosenEndDate: string) => {
    const dateTimeFactory = useDateTime()
    const moneyFactory = useMoney({})

    const formattedStartDate = dateTimeFactory.formatDate(dateTimeFactory.fromISO(chosenStartDate))
    const formattedEndDate = dateTimeFactory.formatDate(dateTimeFactory.fromISO(chosenEndDate))

    const csvOptions = mkConfig({
        fieldSeparator: ";",
        quoteStrings: true,
        decimalSeparator: ".",
        useBom: true,
        useKeysAsHeaders: true,
        filename: `Facilitynet-Subscription-${formattedStartDate}_${formattedEndDate}`,
    })

    const mapSubscriptionToCsvRow = (subscription: SubscriptionOrder) => ({
        From: formattedStartDate,
        To: formattedEndDate,
        "Subscription name": subscription.subscriptionDetails?.name ?? "",
        [`Price (${
            subscription.amount ? moneyFactory.getLocalizedCurrencySymbol(toCurrency(subscription.amount.currency)) : ""
        })`]: subscription.amount ? moneyFactory.formatAsNumber(toDinero(subscription.amount)) : "",
        "Valid from": subscription.subscriptionDetails?.validFrom ?? "",
        "Valid to": subscription.subscriptionDetails?.validTo ?? "",
        Created: subscription.created ? dateTimeFactory.formatDate(dateTimeFactory.fromISO(subscription.created)) : "",
        "Order id": subscription.id ?? "",
        "PSP reference": "",
    })

    const handleExportRows = (rows?: MRT_Row<SubscriptionOrder>[]) => {
        let exportRows: ReturnType<typeof mapSubscriptionToCsvRow>[] = []

        if (rows && rows.length > 0) {
            const rowData = rows.map((row) => row.original)
            exportRows = rowData.map((subscription) => mapSubscriptionToCsvRow(subscription))
        } else {
            exportRows = [mapSubscriptionToCsvRow({} as SubscriptionOrder)]
        }

        const csv = generateCsv(csvOptions)(exportRows)
        download(csvOptions)(csv)
    }

    return { handleExportRows }
}
